import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgObjectifIcon(props) {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={27} height={27} fill="none" viewBox="0 0 27 27" {...props}>
            <Path
                fill={baseColors.green.primary}
                d="M13.5 27C20.956 27 27 20.956 27 13.5S20.956 0 13.5 0 0 6.044 0 13.5 6.044 27 13.5 27z"
            />
            <Path
                fill="#F2F2F2"
                d="M13.5 23.625c-5.569 0-10.125-4.556-10.125-10.125S7.931 3.375 13.5 3.375 23.625 7.931 23.625 13.5 19.069 23.625 13.5 23.625z"
            />
            <Path
                fill={baseColors.orange.primary}
                d="M13.5 20.25c-3.713 0-6.75-3.038-6.75-6.75 0-3.713 3.037-6.75 6.75-6.75 3.712 0 6.75 3.037 6.75 6.75 0 3.712-3.038 6.75-6.75 6.75z"
            />
            <Path
                fill="#CDD6E0"
                d="M13.5 16.875a3.385 3.385 0 01-3.375-3.375 3.385 3.385 0 013.375-3.375 3.385 3.385 0 013.375 3.375 3.385 3.385 0 01-3.375 3.375z"
            />
            <Path
                fill="#FFD15C"
                d="M13.5 16.875a3.385 3.385 0 01-3.375-3.375 3.385 3.385 0 013.375-3.375 3.385 3.385 0 013.375 3.375 3.385 3.385 0 01-3.375 3.375z"
            />
            <Path
                fill="#334A5E"
                d="M26.888 15.187a13.7 13.7 0 01-1.52 4.725l-.73-.28-.957-2.026-10.125-3.656a.874.874 0 01-.506-1.125.874.874 0 011.125-.506L24.3 15.975l2.025-.956.563.168z"
                opacity={0.2}
            />
            <Path
                fill="#40596B"
                d="M22.725 5.456l-8.269 8.27a.883.883 0 01-1.237 0 .883.883 0 010-1.238l8.325-8.213a.883.883 0 011.237 0 .87.87 0 01-.056 1.181z"
            />
            <Path fill={baseColors.orange.primary} d="M23.512 3.487L20.87 6.131V2.644L23.512 0v3.487z" />
            <Path fill="#EB6800" d="M24.356 6.132L27 3.488h-3.488L20.87 6.132h3.487z" />
        </Svg>
    )
}

export default SvgObjectifIcon
